import { SENTIMENT_CLASSES } from "@/lib/format";
import { cn } from "@/lib/utils";

export function SentimentBadge({ sentiment, className }) {
  const s = (sentiment || "neutral").toLowerCase();
  return (
    <span
      data-testid={`sentiment-badge-${s}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize",
        SENTIMENT_CLASSES[s] || SENTIMENT_CLASSES.neutral,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s}
    </span>
  );
}
